import React, { Component } from 'react';
import PropTypes from 'prop-types';


import Divider from '@mui/material/Divider';
import { Box } from '@mui/material';
// import Button from '@mui/material/Button';
// import FileUploadIcon from '@mui/icons-material/CloudUpload';

const s:any = {
  container: {
    display: 'flex',
    justifyContent:'flex-start',
    alignItems: 'center'
  },
  preview: {
    width:200,
    height: 40,
    mt: 1,
    ml: 1,
    mr: 1,
  },
  button: {
    m: 1
  },
  input: {
    display: 'none',
  },
  hidden: {
    display: 'none'
  },
  visible: {
    display: 'flex'
  }
};

class FPhotoField extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);
    this.state = {
      loading: false,
      open: false,
      source: undefined
    };
  }

  render() {
    const { base, label, value, previewStyle, divider, classes } = this.props;
    //const {id,name,label,preview,previewStyle,divider,classes} = this.props;
    //const {source} = this.state;
    //var accept = "image/*";
    const basePath = base || '/api/photo/';
    const srcPath = basePath+value;
    return (
      <Box>
      <Box sx={{...s.container}}>
        {/* <input
          accept={accept}
          sx={{...s.input}}
          id={id}
          name={name}
          type="file"
          onChange={this.onChange}
        /> */}
        <Box component='span'>
            {label}
        </Box>
        <Box component='img' 
          sx={{...s.preview}} 
          style={previewStyle||{}} 
          src={srcPath} 
          alt={""}
        />
      </Box>
      {divider && <Divider />}
      </Box>
    );
  }
}

// FPhotoField.propTypes = {
//   //classes: PropTypes.object.isRequired,
//   //children: PropTypes.any.isRequired,
//   //label: PropTypes.string.isRequired,
//   value: PropTypes.string.isRequired,
// };

export default FPhotoField;